// extracted by mini-css-extract-plugin
export default {"eventDetailsContent":"EventsDetails_eventDetailsContent__xqkqE","eventInfo":"EventsDetails_eventInfo__X5Tmy","aboutThisEvent":"EventsDetails_aboutThisEvent__OWCzb"};